<template>
    <div class="pending-profile">
        <div class="header">
            <h2>{{ $t('Application request in judgement') }}</h2>
            <p>{{ $t('Your application request is being reviewed') }}</p>
        </div>
        <v-icon class="notranslate">fa-gavel</v-icon>
    </div>
</template>

<script>
  export default {
    name: 'PendingProfile'
  }
</script>

<style lang="scss">
    .pending-profile {
        padding: 48px 24px;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .header {
            max-width: 640px;
            text-align: center;
        }
        .v-icon {
            font-size: 156px;
            margin: 48px;
            color: rgba(0,0,0,0.38);
        }
    }
</style>

<i18n>
    {
        "en": {
            "Application request in judgement": "Application request in judgement",
            "Your application request is being reviewed": "Your application request for this segment is being reviewed by our team. Once you're approved, you'll be notified."
        },
        "pt": {
            "Application request in judgement": "Solicitação de adesão em julgamento",
            "Your application request is being reviewed": "Sua solicitação de adesão para esse segmento está sendo analisada pela nossa equipe. Ao ser aprovado, você será notificado."
        }
    }
</i18n>
